export class FindPartnersForm {
  servicesOffered: string[];
  focusAreas: string[];

  possibleServices: string[] = [
    "emailNewsLetter",
    "lessonPlans",
    "lessonSupplies",
    "techSupport",
    "speakerVol",
    "virtualFT",
    "inpersonFT",
    "serviceProject",
    "internships",
    "scholarships"
  ];
  
  possibleFocusAreas: string[] = [
    "cleanAir",
    "cleanWater",
    "foodWaste",
    "composting",
    "recycling",
    "habitats",
    "pollinators"
  ];

  // Display labels for each filter
  filterLabels: { [key: string]: string } = {
    emailNewsLetter: 'Email/Newsletters',
    lessonPlans: 'Lesson Plans',
    lessonSupplies: 'Lesson Supplies',
    techSupport: 'Technical Support',
    speakerVol: 'Speaker/Volunteers',
    virtualFT: 'Virtual Field Trips',
    inpersonFT: 'In-person Field Trips',
    serviceProject: 'Service Projects',
    internships: 'Internships',
    scholarships: 'Scholarships',

    cleanAir: 'Clean Air',
    cleanWater: 'Clean Water',
    foodWaste: 'Food Waste',
    composting: 'Composting',
    recycling: 'Recycling',
    habitats: 'Habitats',
    pollinators: 'Pollinators'
  };

  constructor() {
    this.servicesOffered = [];
    this.focusAreas = [];

    // this.servicesOffered = {
    //   emailNewsLetter: false,
    //   lessonPlans: false,
    //   lessonSupplies: false,
    //   techSupport: false,
    //   speakerVol: false,
    //   virtualFT: false,
    //   inpersonFT: false,
    //   serviceProject: false,
    //   internships: false,
    //   scholarships: false,
    // };
    
    // this.focusAreas = {
    //   cleanAir: false,
    //   cleanWater: false,
    //   foodWaste: false,
    //   composting: false,
    //   recycling: false,
    //   habitats: false,
    //   pollinators: false,
    // };
  }
}

